import {Button} from '@wandb/components';
import React, {FC} from 'react';
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from 'react-toastify';

import {useTriggerRecomputeKeysInfoMutation} from '../generated/graphql';
import {useAdminModeActive} from '../util/admin';

type RunTriggerRecomputeKeysInfoProps = {
  runID: string;
};

export const RunTriggerRecomputeKeysInfo: FC<
  RunTriggerRecomputeKeysInfoProps
> = ({runID}: RunTriggerRecomputeKeysInfoProps) => {
  const isAdmin = useAdminModeActive();
  const [triggerRecomputeKeysInfo] = useTriggerRecomputeKeysInfoMutation();

  if (!isAdmin) {
    return null;
  }

  const onClick = async () => {
    try {
      const response = await triggerRecomputeKeysInfo({
        variables: {runId: runID},
      });
      if (response.errors != null) {
        toast('error triggering recompute keys info');
        return;
      }
      const taskID = response.data?.triggerRecomputeKeysInfo?.task?.id;
      if (taskID != null) {
        toast(`succesfully triggered recompute keys info ${taskID}`);
      }
    } catch (err) {
      toast(`error triggering recompute keys info ${err}`);
    }
  };

  return (
    <Button size="sm" onPress={onClick}>
      Trigger
    </Button>
  );
};
